import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Fragment as _Fragment, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/icon_back_m.svg'
import _imports_1 from '@/assets/icons/icon_pre_step.svg'
import _imports_2 from '@/assets/icons/icon_close.svg'
import _imports_3 from '@/assets/images/layout/APP_LOGO.svg'


const _hoisted_1 = { class: "login-register-head" }
const _hoisted_2 = { class: "head-sec-control left-section" }
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1
}
const _hoisted_6 = { class: "head-sec-control center-section" }
const _hoisted_7 = { class: "head-sec-control right-section" }
const _hoisted_8 = {
  key: 1,
  class: "login-container"
}
const _hoisted_9 = {
  key: 2,
  class: "register-container"
}
const _hoisted_10 = {
  key: 3,
  class: "forget-password-container"
}

import { ref, computed, onMounted, nextTick, watch } from "vue";
import { NIcon } from "naive-ui";
// import { ChevronBack } from "@vicons/ionicons5";
import LoginMain from "./setModules/LoginMain.vue";
import LoginMainMobile from "./setModules/LoginMainMobile.vue";
import RegisterMain from "./setModules/RegisterMain.vue";
import ForgetPasswordMain from "./setModules/ForgetPasswordMain.vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useNavigatorSystem } from "@/composables/useNaviSystem";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginAndRegister',
  props: {
    showClose: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
    showRegister: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
    showForgotpasword: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
},
  emits: ["closeLoginAndRegisterModal"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;
const store = useStore();
const router = useRouter();
const { isMobile } = useNavigatorSystem();

const showMessageCont = ref<string>("login");
const currentLoginStep = ref<number>(1);
const createAccountStep = ref<number>(1);
const forgetPasswordStep = ref<number>(1);
const curCompletePersonalInformationStep = ref<number>(1);

// 弹窗标题
const loginAndRegisterTitle = computed(() => {
    let res = "Log In";
    switch (showMessageCont.value) {
        case "login":
            res =
                currentLoginStep.value === 1
                    ? isMobile.value
                        ? "Charm"
                        : "Log In"
                    : "Log In";
            break;
        case "register":
            if (createAccountStep.value === 2) {
                res = "Verify your identity";
            } else if (createAccountStep.value === 4) {
                res =
                    curCompletePersonalInformationStep.value === 1
                        ? "Complete personal information"
                        : "Your Interests";
            } else {
                res = "Create Account";
            }
            break;
        case "forgetPassword":
            res =
                forgetPasswordStep.value === 1 ||
                forgetPasswordStep.value === 2 ||
                forgetPasswordStep.value === 3
                    ? "Forgotten Password？"
                    : "";
            break;
        default:
            break;
    }
    return res;
});

const onChangeCurUserInfoStep = (step: number) => {
    curCompletePersonalInformationStep.value = step;
};

const _handleShowLogin = () => {
    showMessageCont.value = "login";
};

const _goToPageDoctorProfile = () => {
    router.push({ path: "/user/profile", query: { from: "user" } });
};

const _handleShowRegister = async (type?: string) => {
    if (type === "thirdlogin") {
        const cacheUserThirdType = store.getters["user/getUserThirdType"];
        if (cacheUserThirdType === "0") {
            showMessageCont.value = "register";
            createAccountStep.value = 3;
        } else {
            await store.dispatch("user/fetchUserInfo");
            _goToPageDoctorProfile();
            nextTick(() => {
                closeLoginAndRegisterModal();
            });
        }
    } else {
        showMessageCont.value = "register";
    }
};

const _setCreateAccountStep = (step: number) => {
    createAccountStep.value = step ?? 1;
}

const _handleShowForgotPassword = () => {
    showMessageCont.value = "forgetPassword";
}

const _setForgotPasswordStep = (step: number) => {
    forgetPasswordStep.value = step ?? 1;
}

// 忘记密码
const _handleEditPassword = () => {
    _handleShowForgotPassword();
    _setForgotPasswordStep(1);
};

//登录时后退一步
const prevLoginStep = () => {
    if (currentLoginStep.value === 2) {
        currentLoginStep.value = 1;
    } else {
        currentLoginStep.value--;
    }
};

// 注册时后退一步
const prevRegisterStep = () => {
    if (createAccountStep.value === 1) {
        showMessageCont.value = "login";
    } else if (createAccountStep.value === 6) {
        createAccountStep.value = 4;
    } else if (createAccountStep.value === 7 || createAccountStep.value === 8) {
        createAccountStep.value = 1;
    } else if(createAccountStep.value === 4) {
        if (curCompletePersonalInformationStep.value > 1) {
            curCompletePersonalInformationStep.value--;
        } else {
            createAccountStep.value--;
        }
    }else{
        createAccountStep.value--;
    }
};

// 忘记密码时后退一步
const prevForgetPasswordStep = () => {
    if (forgetPasswordStep.value === 1) {
        showMessageCont.value = "login";
    } else if (forgetPasswordStep.value === 4) {
        forgetPasswordStep.value -= 2;
    } else {
        forgetPasswordStep.value--;
    }
};

// 关闭登陆注册弹框
const closeLoginAndRegisterModal = () => {
    emits("closeLoginAndRegisterModal");
    showMessageCont.value = "login";
    createAccountStep.value = 1;
};

const _initUserLoginInfo = () => {
    //清理缓存 undo
    //清理用户信息 undo
};

watch(
    ()=>props.showRegister,
    (n:boolean) => {
        if(n){
            nextTick(() => {
                _handleShowRegister();
                _setCreateAccountStep(7);
            })
        }
    },
    {immediate: true}
);

watch(
    ()=>props.showForgotpasword,
    (n:boolean) => {
        if(n){
            nextTick(() => {
                _handleShowForgotPassword();
                _setForgotPasswordStep(3);
            })
        }
    },
    {immediate: true}
);

onMounted(() => {
    nextTick(() => {
        _initUserLoginInfo();
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["login-register-modal", {
            'mobile-login-container': _unref(isMobile),
            'mobile-login-bg': _unref(isMobile) && currentLoginStep.value === 1 && showMessageCont.value === 'login',
        }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (showMessageCont.value === 'login' && currentLoginStep.value !== 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "prev-step-cont",
              onClick: prevLoginStep
            }, [
              (_unref(isMobile))
                ? (_openBlock(), _createBlock(_unref(NIcon), {
                    key: 0,
                    size: "20",
                    class: "custom-icon"
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("img", {
                        class: "icon-img",
                        src: _imports_0
                      }, null, -1)
                    ])),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("img", _hoisted_3))
            ]))
          : _createCommentVNode("", true),
        (showMessageCont.value === 'register' && (createAccountStep.value !== 5 && createAccountStep.value !== 7))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "prev-step-cont",
              onClick: prevRegisterStep
            }, [
              (_unref(isMobile))
                ? (_openBlock(), _createBlock(_unref(NIcon), {
                    key: 0,
                    size: "20",
                    class: "custom-icon"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createElementVNode("img", {
                        class: "icon-img",
                        src: _imports_0
                      }, null, -1)
                    ])),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("img", _hoisted_4))
            ]))
          : _createCommentVNode("", true),
        (showMessageCont.value === 'forgetPassword')
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "prev-step-cont",
              onClick: prevForgetPasswordStep
            }, [
              (_unref(isMobile))
                ? (_openBlock(), _createBlock(_unref(NIcon), {
                    key: 0,
                    size: "20",
                    class: "custom-icon"
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createElementVNode("img", {
                        class: "icon-img",
                        src: _imports_0
                      }, null, -1)
                    ])),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("img", _hoisted_5))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (createAccountStep.value !== 5 && createAccountStep.value !== 6)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["logo-cont", {
                            'pdt-fix': createAccountStep.value === 4,
                            'mobile-cont': _unref(isMobile) && currentLoginStep.value === 1 && showMessageCont.value === 'login',
                        }])
                  }, [
                    _withDirectives(_createElementVNode("div", {
                      class: _normalizeClass({ 'step-text': _unref(isMobile) && currentLoginStep.value === 1 && showMessageCont.value === 'login' })
                    }, _toDisplayString(loginAndRegisterTitle.value), 3), [
                      [_vShow,  !(_unref(isMobile) && showMessageCont.value === 'login' && currentLoginStep.value !== 1)]
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("div", {
          class: "close-cont",
          onClick: closeLoginAndRegisterModal
        }, _cache[7] || (_cache[7] = [
          _createElementVNode("img", { src: _imports_2 }, null, -1)
        ]), 512), [
          [_vShow, __props.showClose]
        ])
      ])
    ]),
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _withDirectives(_createElementVNode("div", {
            class: "close-cont",
            onClick: closeLoginAndRegisterModal
          }, _cache[8] || (_cache[8] = [
            _createElementVNode("img", { src: _imports_2 }, null, -1)
          ]), 512), [
            [_vShow, __props.showClose]
          ]),
          (createAccountStep.value !== 5 && createAccountStep.value !== 6)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["logo-cont", {
                    'pdt-fix': createAccountStep.value === 4,
                    'mobile-cont': _unref(isMobile) && currentLoginStep.value === 1 && showMessageCont.value === 'login',
                }])
              }, [
                _cache[9] || (_cache[9] = _createElementVNode("img", { src: _imports_3 }, null, -1)),
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass({ 'step-text': _unref(isMobile) && currentLoginStep.value === 1 && showMessageCont.value === 'login' })
                }, _toDisplayString(loginAndRegisterTitle.value), 3), [
                  [_vShow,  !(_unref(isMobile) && showMessageCont.value === 'login' && currentLoginStep.value !== 1)]
                ])
              ], 2))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (showMessageCont.value === 'login')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_unref(isMobile))
            ? (_openBlock(), _createBlock(LoginMainMobile, {
                key: 0,
                currentStep: currentLoginStep.value,
                "onUpdate:currentStep": _cache[0] || (_cache[0] = ($event: any) => ((currentLoginStep).value = $event)),
                onOnClose: closeLoginAndRegisterModal,
                onOnRegister: _handleShowRegister,
                onOnForgotPassword: _handleEditPassword
              }, null, 8, ["currentStep"]))
            : (_openBlock(), _createBlock(LoginMain, {
                key: 1,
                currentStep: currentLoginStep.value,
                "onUpdate:currentStep": _cache[1] || (_cache[1] = ($event: any) => ((currentLoginStep).value = $event)),
                onOnClose: closeLoginAndRegisterModal,
                onOnRegister: _handleShowRegister,
                onOnForgotPassword: _handleEditPassword
              }, null, 8, ["currentStep"]))
        ]))
      : _createCommentVNode("", true),
    (showMessageCont.value === 'register')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(RegisterMain, {
            currentStep: createAccountStep.value,
            "onUpdate:currentStep": _cache[2] || (_cache[2] = ($event: any) => ((createAccountStep).value = $event)),
            "cur-base-info-step": curCompletePersonalInformationStep.value,
            onOnLogin: _handleShowLogin,
            onOnChangeuserInfoStep: onChangeCurUserInfoStep,
            onOnClose: closeLoginAndRegisterModal
          }, null, 8, ["currentStep", "cur-base-info-step"])
        ]))
      : _createCommentVNode("", true),
    (showMessageCont.value === 'forgetPassword')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(ForgetPasswordMain, {
            currentStep: forgetPasswordStep.value,
            "onUpdate:currentStep": _cache[3] || (_cache[3] = ($event: any) => ((forgetPasswordStep).value = $event)),
            onOnLogin: _handleShowLogin
          }, null, 8, ["currentStep"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})